import {
  functionalUpdate,
  PaginationState,
  SortingState,
  TableOptions,
} from '@tanstack/react-table';
import { useMemo, useState } from 'react';
import { DialogProvider } from 'src/contexts/DialogContext/DialogContext';
import { useSellerRoleContext } from 'src/contexts/SellerRoleContext';
import { useUserHasConsignorMasterUIForUserManagement } from 'src/hooks/useUserIsConsignorMasterUI';
import { Table } from 'src/tables/Table';
import { SellerRoleInfo } from 'src/WebApiController';

import { ROLES_TABLE_COLUMNS_CONFIG } from './RolesTableColumnsConfig';

export const PAGE_SIZE = 10;

export const RolesTable = () => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: PAGE_SIZE,
  });
  const [sorting, setSorting] = useState<SortingState>([
    { id: 'name', desc: false },
  ]);
  const { allSellerRoles } = useSellerRoleContext();

  const hasConsignorMasterUIForUserManagement =
    useUserHasConsignorMasterUIForUserManagement();

  const data = useMemo(() => {
    return Object.values(allSellerRoles ?? {});
  }, [allSellerRoles]);

  const options: Partial<TableOptions<SellerRoleInfo | null>> = {
    data,
    columns: ROLES_TABLE_COLUMNS_CONFIG,
    state: {
      pagination,
      sorting,
      columnVisibility: {
        account: hasConsignorMasterUIForUserManagement,
      },
    },
    onPaginationChange: setPagination,
    onSortingChange: (sortingUpdaterFn) => {
      const newSortVal = functionalUpdate(sortingUpdaterFn, sorting);
      setSorting(newSortVal);
    },
  };

  return (
    <DialogProvider>
      <Table options={options} withOuterPadding={true} roundBorders={true} />
    </DialogProvider>
  );
};
